<app-page
  [title]="'Authorization for Pharmacy Order No. ' + orderNumber"
  [isLoading]="(isLoadingPharmOrders$ | async) || (isLoadingPharmAddress$ | async)"
  [error]="error$ | async"
  [centerTitle]="true"
>
  <div class="flex align-items-start justify-content-between mb-5">
    <h1 class="my-0">1.Review & Authorize</h1>
  </div>
  <div class="grid">
    <div class="col-12 lg:col-8">
      <div class="mb-5">
        <p-card>
          <h2 class="mt-0 mb-5">Shipping</h2>
          <hr />
          <p class="p3 m-0" [innerHTML]="" data-cy="contacts-shipping-address"></p>
          <div>
            <div>
              <span>{{ pharmShippingAddress.address1 }}</span>
            </div>
            <div *ngIf="pharmShippingAddress.address2 !== ''">
              <span>{{ pharmShippingAddress.address2 }}</span>
            </div>
            <div>
              <span
                >{{ pharmShippingAddress.city }}, {{ pharmShippingAddress.state }}&nbsp;{{
                  pharmShippingAddress.zip
                }}</span
              >
            </div>
          </div>
          <br /><br />
          <h2 class="mt-0 mb-5">Products</h2>
          <hr />
          <p class="p3 m-0" [innerHTML]="" data-cy="contacts-shipping-address"></p>
          <p-table [value]="pharmOrderItems" responsiveLayout="stack" dataKey="id" class="dashboard-active-orders">
            <ng-template pTemplate="body" let-pharmOrderItems let-expanded="expanded">
              <tr
                [ngClass]="{ 'bottom-not-rounded': expanded, 'bottom-rounded': !expanded }"
                data-cy="orders-list-item"
              >
                <td data-cy="orders-list-item-description" width="85%">
                  <span class="p-column-title" data-cy="orders-list-item-description-header">Item Description</span>
                  {{ pharmOrderItems.drugDescription }}
                </td>
                <td data-cy="orders-list--item-quantity" width="15%">
                  <span class="p-column-title" data-cy="orders-list-item-quantity-header">Qty</span>
                  Qty: {{ pharmOrderItems.quantity }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-card>
      </div>

      <h4>Contact the pharmacy at 1-888-308-8882 to update your account or make changes to an existing order.</h4>
    </div>

    <div class="col-12 lg:col-4">
      <div>
        <p-card data-cy="order-status-widget">
          <div class="field-checkbox mb-0">
            <div class="flex flex-column">
              <!-- TODO refine with reactive forms here -->
              <div class="flex align-items-start">
                <p-checkbox [binary]="true" inputId="binary" (onChange)="onChecked($event)"></p-checkbox>

                <label class="wizard-confirmation-label p-checkbox-label small text-black-400">
                  <span class="text-error-base mr-1 font-medium"> </span>
                  By selecting this box, I am consenting to this Pharmacy order and authorize CCS Medical to charge the
                  credit card I have on file up to $200 for any outstanding balances due for my Pharmacy account.
                </label>
              </div>
            </div>
          </div>
          <div>
            <br /><br />

            <button
              pButton
              type="button"
              class="w-full mb-2"
              [label]="isSubmittingPharmOrder ? 'Submitting Order' : 'Authorize'"
              (click)="onSubmit()"
              [disabled]="!isChecked || isSubmittingPharmOrder"
            ></button>
          </div>
        </p-card>
      </div>
    </div>
  </div>

  <div>
    <app-order-submission-loading-overlay [visible]="isSubmittingPharmOrder"></app-order-submission-loading-overlay>

    <app-notification-overlay
      [(visible)]="displayOrderSubmissionError"
      title="Order Submission Failed"
      message="An error occured while submitting your order. Please review your information and try submitting again."
      [additionalDetails]="'Error Details: ' + (submitPharmReorder$ | async)?.error?.uiMessage"
      type="error"
    ></app-notification-overlay>
  </div>
</app-page>
